export enum ActiesPermissions {
  AssignDiplomas = 'assign-diplomas',
  PrintDiplomaCard = 'print-diplomacard',
  SendChoiceForm = 'send-choice-form',
  ActionsCheckMboSoftCheck = 'actions.check-mbo-soft-check',
}
